package ru.malygin.dto

import kotlinx.serialization.Serializable
import ru.malygin.myConst.CellType
import ru.malygin.myConst.WeekDay


@Serializable
data class MainScheduleItemDto(
    val id: Int,
    val dayOfWeek: WeekDay,
    val actualId: String,
    val lessonStart: String? = null,
    val lessonEnd: String? = null,
    val teacherName: String? = null,
    val roomNum: String? = null,
    val lessonName: String? = null,
    val groupName: String? = null,
    val tutorName: String? = null,
    val dataAdded: String,
    val courseClass: String? = null,
    val cellType: CellType = CellType.STANDARD,
    val colorType: String? = null
)

/**
 * примерный запрос для создания таблицы в PostgresSQL
 *
 * CREATE TABLE testTable
 * (
 *   	testTable_id integer PRIMARY KEY NOT NULL,
 *   	dayOfWeek text NOT NULL,
 *   	actualId text NOT NULL,
 *   	lessonStart text,
 *   	lessonEnd text,
 *   	teacherName text,
 *   	roomNum text,
 *   	lessonName text,
 *   	groupName text,
 *   	tutorName text,
 *   	dataAdded text NOT NULL,
 *   	courseClass text,
 *   	cellType text NOT NULL,
 *   	colorType text
 *  )
 */

/**
 * примерный запрос для создания колонки в PostgresSQL
 *
 * INSERT INTO testTable
 * VALUES
 * (
 * 	1,
 * 	'MONDAY',
 * 	'1',
 * 	NULL,
 * 	NULL,
 * 	NULL,
 * 	NULL,
 * 	'lessonName text',
 * 	NULL,
 * 	NULL,
 * 	'16.09.2024',
 * 	NULL,
 * 	'STANDARD',
 * 	NULL
 * )
 */